import { render } from "./UiLogoutConfirmModal.vue?vue&type=template&id=6f8137e2&lang=pug"
import script from "./UiLogoutConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UiLogoutConfirmModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__